import { Variant as BadgeVariant } from '@blueprint/mini-listing-card/dist/MiniListingCard.types';
import { ListingStatusSummary } from '../../graphql.generated';
import { Similar_Listings_CardFragment } from '../api/similarListings/SimilarListings.query.generated';

export type ClickHandler = (event: React.MouseEvent<HTMLElement>) => void;

export type ImgList = {
    width: number;
    src: string;
};

export type IconId = 'bed' | 'bath' | 'chair';

export type Feature = {
    iconId: IconId;
    content: number;
};

export type Branch = {
    name: string;
    logoUrl: string;
};

export enum ListingCardPortraitMiniIconType {
    BranchIcon = 'branch_icon',
    FavouriteIcon = 'favourite_icon',
    NoIcon = 'no_icon'
}

export type ListingCardPortraitMiniProps = {
    link: string;
    address: Similar_Listings_CardFragment['displayAddress'];
    features: Similar_Listings_CardFragment['featurePreview'];
    image: Similar_Listings_CardFragment['imagePreview'];
    price?: Similar_Listings_CardFragment['pricing']['priceQualifierLabel'];
    branch?: Similar_Listings_CardFragment['branch'];
    priceTitle?: Similar_Listings_CardFragment['pricing']['label'];
    title?: Similar_Listings_CardFragment['title'];
    variant?: BadgeVariant;
    flag?: ListingStatusSummary['label'];
    showIconType?: ListingCardPortraitMiniIconType;
    isListingSaved?: boolean;
    onImageClick?: ClickHandler;
    onCardClick?: ClickHandler;
    onFeaturesClick?: ClickHandler;
    onTitleClick?: ClickHandler;
    onPriceClick?: ClickHandler;
    onSaveClick?: ClickHandler;
    onAddressClick?: ClickHandler;
    onAgentClick?: ClickHandler;
    onLinkClick?: ClickHandler;
};
